export default __webpack_public_path__ + "static/media/Skey-Network-Volcano-Small.5a24efb8.png";